export const RolesList = {
  EndUser: 'EndUser',
  Agents: 'Agents',
  SuperAdmins: 'SuperAdmins',
  EntAdmins: 'EntAdmins'
};
